import { getPickupTemplate } from './PickupTemplateGenerator';
import { getDeliveryTemplate } from './DeliveryTemplateGenerator';
import { getApplianceDeliveryTemplate } from './ApplianceDeliveryTemplateGenerator';

export const getFulfillmentTileModels = ({
  fulfillment,
  type,
  covidAlert,
  quantity,
  zipCode,
  storeId,
  itemId,
  storeName,
  channel,
  pricing,
  thresholds,
  setShowCheckAvailability,
  currentDeliveryFfm,
  shippingData,
  subscriptionEligible = false,
  preferSecondaryFFM = false,
  productType,
  isCartTiles,
  addOnsAssemblyAndMore,
  fallbackMode,
  disableSTH,
  disableBODFS,
  disableBOSS,
  disablePickupNearBy
}) => {

  const shippingTemplate = getDeliveryTemplate({
    fulfillment,
    type,
    zipCode,
    storeId,
    quantity,
    itemId,
    setShowCheckAvailability,
    covidAlert,
    pricing,
    thresholds,
    currentDeliveryFfm,
    shippingData,
    subscriptionEligible,
    preferSecondaryFFM,
    isCartTiles,
    fallbackMode,
    disableSTH,
    disableBODFS
  });

  const storeTemplate = getPickupTemplate({
    channel,
    itemId,
    covidAlert,
    fulfillment,
    type,
    quantity,
    storeName,
    pricing,
    thresholds,
    productType,
    isCartTiles,
    addOnsAssemblyAndMore,
    fallbackMode,
    disableBOSS,
    disableSTH,
    disablePickupNearBy
  });

  return [storeTemplate, shippingTemplate];

};

export const getMajorApplianceTileModels = ({
  applianceDeliveryData,
  fulfillment,
  type,
  covidAlert,
  quantity,
  itemId,
  storeName,
  channel,
  pricing,
  thresholds,
  productType,
  addOnsAssemblyAndMore,
  enableApplianceDeliveryCharge,
  enableFreeDeliveryForExchange,
  isExchangeCustomer,
  isCartTiles
}) => {

  const shippingTemplate = getApplianceDeliveryTemplate({
    applianceDeliveryData,
    pricing,
    enableApplianceDeliveryCharge,
    enableFreeDeliveryForExchange,
    isExchangeCustomer,
    isCartTiles
  });

  const storeTemplate = getPickupTemplate({
    channel,
    itemId,
    covidAlert,
    fulfillment,
    type,
    quantity,
    storeName,
    pricing,
    thresholds,
    productType,
    addOnsAssemblyAndMore
  });

  return [storeTemplate, shippingTemplate];

};
